/** 规范化种类名,便于模糊比对 */
function normalizeSpeciesName(s: string): string {
  return s.replace(/\s+/g, '').toLowerCase();
}

/** 照片识别种类与档案种类是否大致一致 */
export function speciesMatches(
  detected: string | null | undefined,
  expected: string | null | undefined,
): boolean {
  if (!detected?.trim() || !expected?.trim()) return true;
  const a = normalizeSpeciesName(detected);
  const b = normalizeSpeciesName(expected);
  if (a === b) return true;
  if (a.includes(b) || b.includes(a)) return true;
  return false;
}

/** 不一致时返回详情,一致或无法判断时返回 null */
export function getSpeciesMismatch(
  detected: string | null | undefined,
  expected: string | null | undefined,
): { detected: string; expected: string } | null {
  if (!detected?.trim() || !expected?.trim()) return null;
  if (speciesMatches(detected, expected)) return null;
  return { detected: detected.trim(), expected: expected.trim() };
}
